<template>
  <div class="content-container tab-container">
    <overlay-scrollbars
      :options="{ className: 'content-container os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <section class="content large-padding border-bottom">
        <div class="grid-x grid-padding-x grid-padding-large align-items-center">
          <div class="cell large-6 xlarge-7 xxlarge-8">
            <div class="grid-x grid-padding-x grid-padding-large">

              <!-- First -->
              <div class="cell large-12 xxlarge-6">
                <div class="data-grid border-right">
                  <div class="grid-x grid-padding-x grid-padding-small">
                    <div class="cell">
                      <h3 class="icon-heading">
                        <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use
                          xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg></span>
                        <span class="icon-heading-title">
                          <span class="title" v-if="!objekt.subtitle">{{objekt.title}}</span>
                          <span class="title" v-else>{{objekt.title}} / {{objekt.subtitle}}</span>
                          <span class="subtitle" style="font-size:0.78rem;">{{objekt.Objektnr}}</span>
                        </span>
                      </h3>
                    </div>

                    <div class="cell small-6 large-6 border-top">
                      <div class="dl-wrap">
                        <span class="dl dt">Kategori</span>
                        <span class="dl dd" v-if="objekt.kategori">{{objekt.kategori.Kategori}}, {{objekt.kategori.Beskrivelse}}</span>
                        <span class="dl dd" v-else>-</span>
                        <span class="dl dd" style="color: dimgray;" v-if="objekt.kategori_sekundaer">{{objekt.kategori_sekundaer.Kategori}}, {{objekt.kategori_sekundaer.Beskrivelse}}</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top">
                      <div class="dl-wrap">
                        <span class="dl dt">
                          Auksjon
                          <span v-if="auctionInProgress">
                            <a href="javascript:;" @click="showRemoveObjectConfirm()">Fjern fra auksjon</a>
                            <a href="javascript:;" @click="showChangeObjectAuction()">Bytt</a>
                          </span>
                        </span>
                        <span class="dl dd" v-if="objekt.Auksjon">
                          {{objekt.Auksjon}} <span v-if="objekt.auksjon"> ({{objekt.auksjon.Beskrivelse}})</span>
                          <span v-if="prevAuksjon" class="opacity-60" style="font-size:0.7rem;"><br><em>{{prevAuksjon}}</em></span>
                        </span>
                        <span class="dl dd" v-else>-</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top" v-if="auctionStart">
                      <div class="dl-wrap">
                        <span class="dl dt">Auksjon start</span>
                        <span class="dl dd">{{auctionStart}}</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top" v-if="auctionEnd">
                      <div class="dl-wrap">
                        <span class="dl dt">Auksjon slutt</span>
                        <span class="dl dd">{{auctionEnd}}</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top">
                      <div class="dl-wrap">
                        <span class="dl dt">Auksjonsdato</span>
                        <span class="dl dd">{{auctionDate || '-'}}</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top" v-if="prevListAuksjon">
                      <div class="dl-wrap">
                        <span class="dl dt">Tidligere auksjon</span>
                        <span class="dl dd">{{prevListAuksjon}}</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top" v-if="objekt.Avdelingsid != 0" >
                      <div class="dl-wrap">
                        <span class="dl dt">Antall ganger i auksjon</span>
                        <span class="dl dd">{{objekt.amount_of_times_in_auction }}</span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top" v-if="objekt.Avdelingsid == 0 && !prevListAuksjon">
                      <div class="dl-wrap">
                        <span class="dl dt"></span>
                        <span class="dl dd"></span>
                      </div>
                    </div>

                    <div class="cell small-6 large-6 border-top" style="margin-bottom: 5rem;">
                      <div class="dl-wrap">
                        <span class="dl dt">Lagerleie</span>
                        <span class="dl dd" v-if="canStartLagerleie">
                          <a href="javascript:;" v-if="!lagerleieStartState" @click="showStartLagerLeieConfirm()">Start lagerleie</a>
                          <span v-else-if="lagerleieStartState === 'sending'">Starter lagerleie...</span>
                          <span v-else-if="lagerleieStartState === 'success'">Lagerleie har startet</span>
                        </span>
                        <span class="dl dd" v-else-if="lagerleie.state === false">-</span>
                        <span class="dl dd" v-else-if="loadingLagerleie">Sjekker...</span>
                        <span class="dl dd" v-else-if="lagerleie.began === false">
                          <span v-if="!lagerleieStartState">
                            Aktivert: {{lagerleie.start | norwegiandate}}<br>
                            Betaling fra: {{lagerleie.startCharging | norwegiandate}}<br>
                            Stoppet: {{lagerleie.stop  | norwegiandate}}<br>
                          </span>
                          <span v-else-if="lagerleieStartState === 'sending'">
                            Aktivert: oppdatering...<br>
                            Betaling fra: oppdatering...<br>
                            Stoppet: oppdatering...<br>
                          </span>
                          <span v-else-if="lagerleieResetState === 'success'">
                            Aktivert: {{lagerleie.start | norwegiandate}}<br>
                            Betaling fra: {{lagerleie.startCharging | norwegiandate}}<br>
                            Stoppet: {{lagerleie.stop  | norwegiandate}}<br>
                          </span>
                          <template v-if="!objekt.Lev_dato && isPresenceOwner">
                            <template v-if="!objekt.LagerleieStoppDato">
                              <br>
                              <a href="javascript:;" v-if="!lagerleieStopState" @click="showStopLagerLeieConfirm()">Stopp lagerleie</a>
                              <span v-else-if="lagerleieStopState === 'sending'">Stopper lagerleie...</span>
                              <span v-else-if="lagerleieStopState === 'success'">Lagerleie har stoppet</span>
                            </template>
                              <br>
                              <a href="javascript:;" v-if="!lagerleieResetState" @click="showResetLagerLeieConfirm()">Nullstill lagerleie</a>
                              <span v-else-if="lagerleieResetState === 'sending'">Nullstill lagerleie...</span>
                              <span v-else-if="lagerleieResetState === 'success'">Lagerleie er tilbakestilt</span>
                          </template>
                        </span>
                        <span class="dl dd" v-else-if="lagerleie.began === true">
                          Aktivert: {{lagerleie.start  | norwegiandate}}<br>
                          Betaling fra: {{lagerleie.startCharging  | norwegiandate}}<br>
                          Stoppet: {{lagerleie.stop  | norwegiandate}}<br>
                          Påløpt: {{lagerleie.weeks}} {{lagerleie.weeks === 1 ? ' uke' : ' uker'}}<br>
                          Pris: {{lagerleie.price}}kr
                          <template v-if="!objekt.Lev_dato && isPresenceOwner">
                            <template v-if="!objekt.LagerleieStoppDato">
                              <br>
                              <a href="javascript:;" v-if="!lagerleieStopState" @click="showStopLagerLeieConfirm()">Stopp lagerleie</a>
                              <span v-else-if="lagerleieStopState === 'sending'">Stopper lagerleie...</span>
                              <span v-else-if="lagerleieStopState === 'success'">Lagerleie har stoppet</span>
                            </template>
                              <br>
                              <a href="javascript:;" v-if="!lagerleieResetState" @click="showResetLagerLeieConfirm()">Nullstill lagerleie</a>
                              <span v-else-if="lagerleieResetState === 'sending'">Nullstill lagerleie...</span>
                              <span v-else-if="lagerleieResetState === 'success'">Lagerleie er tilbakestilt</span>
                          </template>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End First -->

              <!-- Second -->
              <div class="cell large-12 xxlarge-6">
                <div class="data-grid">
                  <div class="grid-x grid-padding-x grid-padding-small">
                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Lav vurdering</span>
                        <span class="dl dd">{{objekt.Vurderingspris2 | thousands}}</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Høy vurdering</span>
                        <span class="dl dd">{{objekt.Vurderingspris1 | thousands}}</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Minstepris</span>
                        <span class="dl dd">{{objekt.Minstepris | thousands}}</span>
                      </div>
                    </div>

                    <div class="cell small-8 shrink border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Status</span>
                        <span class="dl dd">
                          <span class="status green" v-if="objekt.Lev_dato">Utlevert: {{objekt.Lev_dato | avantidate}}</span>
                          <span class="status red" v-else>Ikke utlevert</span>
                          &nbsp;
                          <span class="status green" v-if="objekt.Bet_dato">Betalt: {{objekt.Bet_dato | avantidate}}</span>
                          <span class="status red" v-else>Ubetalt</span>
                        </span>
                      </div>
                    </div>

                    <div class="cell small-4 shrink border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Fraktgruppe</span>
                        <span class="dl dd">{{ objekt.fraktgruppe ? objekt.fraktgruppe.Beskrivelse : '-'}}</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Tilslag</span>
                        <span class="dl dd">{{objekt.Salgspris | thousands}} kr</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Salær</span>
                        <span class="dl dd">{{objekt.Salar || 0 | toFixed}}% </span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Auksjonshonorar</span>
                        <span class="dl dd">{{objekt.fotokostnad_calculated | thousands}} kr</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Objekt (tekst)</span>
                        <span class="dl dd">
                          <span v-if="objekt.Tekst_ok === 'T'" class="statusicon verified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
                          <span v-else class="statusicon unverified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
                        </span>
                      </div>
                    </div>
                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Foto</span>
                        <span class="dl dd">
                          <span v-if="objekt.Fototatt === 'T'" class="statusicon verified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
                          <span v-else class="statusicon unverified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
                        </span>
                      </div>
                    </div>
                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Signert</span>
                        <span class="dl dd">
                          <span v-if="objekt.kontrakt.Registrertsignert" class="statusicon verified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
                          <span v-else class="statusicon unverified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
                        </span>
                      </div>
                    </div>
                    <!--
                    <div class="cell small-6 shrink">
                      <span class="status green" v-if="objekt.Bet_dato">Betalt: {{objekt.Bet_dato | avantidate}}</span>
                      <span class="status red" v-else>Ikke betalt</span>
                    </div>

                    <div class="cell small-6 shrink">
                      <span class="status green" v-if="objekt.Fakturert === 'F'">Fakturert: {{objekt.Fakturadato | avantidate}}</span>
                      <span class="status red" v-else>Ikke fakturert</span>
                    </div>
                    -->
                  </div>
                </div>
              </div>
              <!-- End Second -->
            </div>
          </div>

          <!-- Images -->
          <div class="cell auto">
            <div class="cell auto">
              <div class="card no-margin no-padding">
                <div class="object-image-slider">
                  <!-- IMAGE SLIDER -->
                  <TheImageSlider :items="objektImages" :objekt="objekt"/>
                  <!-- IMAGE SLIDER -->
                </div>
              </div>
            </div>
            <div class="cell auto" style="margin-top: 5px; text-align: center;">
              <div class="dl-wrap" v-if="isPresenceOwner">
                <span class="dl dt" v-if="!reloadingPhotos"><a @click="reloadPhotos()" href="javascript:;">Hent bilder fra ResourceSpace...</a></span>
                <span class="dl dt opacity-60" v-else>Henter bilder fra ResourceSpace...</span>
              </div>
            </div>
          </div>
          <!-- End Images -->
        </div>
      </section>

      <section class="content white large-padding flex-grow">
        <div class="grid-x grid-padding-x grid-padding-large">
          <div class="cell" :class="[attributes.length > 0 ? 'large-6' : 'large-12']">
            <div class="accordion">
              <ul>
                <li class="active">
                  <div class="accordion-title">
                    <template v-if="objekt.Expertavdelingsid === 2 || objekt.Expertavdelingsid === 5">
                      Navn på verk
                    </template>
                    <template v-else>
                      Tittel/Objekt
                    </template>
                  </div>
                  <div class="accordion-content">
                    <!-- <p v-html="$options.filters.nlbr(objekt.Katalogtekst1)">{{objekt.Katalogtekst1}}</p> -->
                    <TheTextInput containerClassName="cell large-12" :hideLabel="true" name="Katalogtekst1"
                      v-model.trim="form.Katalogtekst1" maxlength="100" :disabled="!isPresenceOwner"/>
                    <!-- <p contenteditable="true" ref="Katalogtekst1" @blur="saveObjektText('Katalogtekst1', objekt.Katalogtekst1)">{{objekt.Katalogtekst1}}</p> -->
                  </div>
                </li>
                <li class="active">
                  <div class="accordion-title">
                    Beskrivelse/Stilperiode
                  </div>
                  <div class="accordion-content">
                    <!-- <p v-html="$options.filters.nlbr(objekt.Objekt3)">{{objekt.Objekt3}}</p> -->
                    <TheTextArea containerClassName="cell large-12" :hideLabel="true" name="Objekt3"
                      v-model="form.Objekt3" :rows="4" maxlength="100" :autoResize="true" :disabled="!isPresenceOwner"/>
                  </div>
                </li>
                <li class="active">
                  <div class="accordion-title">
                    Tekst
                  </div>
                  <div class="accordion-content">
                    <!-- <p v-html="$options.filters.nlbr(objekt.Katalogtekst2)">{{objekt.Katalogtekst2}}</p> -->
                    <TheTextArea containerClassName="cell large-12" :hideLabel="true" name="Katalogtekst2"
                    v-model="form.Katalogtekst2" :rows="4" :autoResize="true" :disabled="!isPresenceOwner"/>
                  </div>
                </li>
                <li class="active">
                  <div class="accordion-title">
                    Merknad
                  </div>
                  <div class="accordion-content">
                    <!-- <p v-html="$options.filters.nlbr(objekt.NettMerknad)">{{objekt.NettMerknad}}</p> -->
                    <TheTextArea containerClassName="cell large-12" :hideLabel="true" name="NettMerknad"
                    v-model="form.NettMerknad" :rows="4" :autoResize="true" :disabled="!isPresenceOwner"/>
                  </div>
                </li>
                <li class="active">
                  <div class="accordion-title">
                    Rettelse
                  </div>
                  <div class="accordion-content">
                    <!-- <p v-html="$options.filters.nlbr(objekt.Rettelse)">{{objekt.Rettelse}}</p> -->
                    <TheTextArea containerClassName="cell large-12" :hideLabel="true" name="Rettelse"
                    v-model="form.Rettelse" :rows="4" :autoResize="true" :disabled="!isPresenceOwner"/>
                  </div>
                </li>
                <li class="active">
                  <div class="accordion-title">
                    <template v-if="savingForm === 'location' || !isPresenceOwner">
                      <a href="javascript:;" class="button primary" disabled>Lagre</a>
                    </template>
                    <template v-else>
                      <a v-if="$store.getters.isFormSubmittable" href="javascript:;" class="button primary"
                         @click="saveForm('text')">Lagre</a>
                      <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary  loading"
                         disabled>Lagrer...<span class="loader-spinner"></span></a>
                      <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary "
                         disabled>Lagre</a>
                    </template>
                  </div>
                </li>
              </ul>
            </div>

          </div>

          <div class="cell large-6" v-if="attributes.length > 0">
            <div class="card" :class="[attributes.length === 2 ? 'dl-half' : 'dl-full']">
              <dl v-for="(attributeList, listIndex) in attributes" v-bind:key="'list-' + listIndex">
                <template v-for="(item, itemIndex) in attributeList">
                  <dt v-bind:key="'idx-' + itemIndex">{{item.name}}</dt>
                  <dd v-bind:key="'val-' + itemIndex" v-if="!item.isLink">{{item.value}}</dd>
                  <dd v-bind:key="'val-' + itemIndex" v-else><a class="external-link" :href="item.value" target="_blank">{{item.value}}</a></dd>
                </template>
              </dl>
            </div>

            <div class="card dl-full">
              <div class="grid-x grid-padding-x">
                <TheSelectInput containerClassName="cell large-4" label="Lokasjon" v-model="form.Lokasjonid" :items="lokasjonDropdown" name="Lokasjonid" required v-validate="'required'"/>
                <div class="cell large-5">
                  <label for="Utlopsdato">Utlevert dato <span v-show="requireLevDato">*</span></label>
                  <div class="input-container date dropdown-top" :class="{'form-error': errors.has('Lev_dato')}">
                    <b-datepicker
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      :disabled="!form.Lokasjonid || !(parseInt(form.Lokasjonid) === 159 || parseInt(form.Lokasjonid) === 327)"
                      v-validate="{'required': parseInt(form.Lokasjonid) === 159 || parseInt(form.Lokasjonid) === 327}"
                      v-model="form.Lev_dato"
                      name="Lev_dato"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="Lev_dato"
                      id="Lev_dato">
                    </b-datepicker>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use
                      xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    <span class="form-error-label" v-if="errors.has('Lev_dato')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Lev_dato')}}
                    </span>
                  </div>
                </div>
                <div class="cell shrink align-right">
                  <label>&nbsp;</label>
                  <template v-if="savingForm === 'text'">
                    <a href="javascript:;" class="button primary" disabled>Lagre</a>
                  </template>
                  <template v-else>
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" class="button primary "
                       @click="saveForm('location')">Oppdater lok.</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary loading"
                       disabled>Oppdater lok.<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary" disabled>Oppdater lok.</a>
                  </template>
                </div>
              </div>

              <div class="grid-x grid-padding-x">
                <div class="cell">
                  <label>Siste lokasjon</label>
                  <span style="font-size: 0.75rem;">{{objekt.Sistelokasjon || '-'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </overlay-scrollbars>
  </div>
</template>

<script>
import TheImageSlider from '../TheImageSlider'
import ObjektService from '@/services/ObjektService'
import NettAuksjonService from '@/services/NettAuksjonService'
import KundeService from '@/services/KundeService'
import InstillingerService from '@/services/InstillingerService'
import moment from 'moment'
import accounting from 'accounting-js'
import bus from '@/plugins/event-bus'
import AuksjonService from '@/services/AuksjonService'

/** Hardcoded Vare ID for Lagerleie */
const LAGERLEIE_VARE_ID = 49
const LAGERLEIE_VIN_VARE_ID = 79

export default {
  name: 'KundeKontraktObjektTabOversikt',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheImageSlider
  },
  data () {
    return {
      lastLokId: 0,
      objektImages: [],
      attributes: [],
      lokDropdown: [],
      form: {},
      savingForm: null,
      reloadingPhotos: false,
      loadingLagerleie: true,
      lagerleiePrice: 0,
      lagerleieStartState: null,
      lagerleieStopState: null,
      lagerleieResetState: null,
      presenceChannelName: null
    }
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  created () {
    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid
  },
  mounted () {
    this.setFormLoading(true)

    if (this.objekt.photos && this.objekt.photos.verylarge && this.objekt.photos.verylarge.length > 0) {
      this.objektImages = this.objekt.photos.verylarge
    } else {
      this.objektImages = []

      ObjektService.getPhotoUrls(this.objekt.Objektnr, 'verylarge')
        .then((response) => {
          this.objektImages = response.data
        })
    }

    this.lastLokId = Number(localStorage.new_obj_lokasjonid || 0)

    this.setupForm()
    this.fetch()
    this.addAttributes()
  },
  computed: {
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    },
    lokasjonDropdown: function () {
      let retval = []

      if (this.$store.getters.isFormLoading) {
        retval.unshift({key: this.objekt.Lokasjonid, val: 'Laster...'})
        return retval
      }

      if (this.lastLokId || this.form.Lokasjonid) {
        // Find last && curr in array
        const last = this.lastLokId ? this.lokDropdown.find(x => x.key === this.lastLokId) : false
        const curr = this.form.Lokasjonid ? this.lokDropdown.find(x => x.key === this.form.Lokasjonid) : false

        if (last || curr) {
          // Remove last && curr from array
          const rest = this.lokDropdown.filter(el => {
            return el.key !== this.lastLokId && el.key !== this.form.Lokasjonid
          })

          // Add the rest to return value
          retval = rest

          // Now add top the top of array, in reverse order...
          retval.unshift({key: null, val: '-------------', disabled: true})

          if (last && curr) {
            // Both exists, add one and then the other if not the same
            retval.unshift({key: last.key, val: last.val})

            if (last.key !== curr.key) {
              retval.unshift({key: curr.key, val: curr.val})
            }
          } else if (last) {
            retval.unshift({key: last.key, val: last.val})
          } else if (curr) {
            retval.unshift({key: curr.key, val: curr.val})
          }

          retval.unshift({key: null, val: 'Velg lokasjon', disabled: true})

          return retval
        }
      }

      retval = this.lokDropdown
      retval.unshift({key: null, val: 'Velg lokasjon', disabled: true})

      return retval
    },
    requireLevDato: function () {
      const val = parseInt(this.form.Lokasjonid)
      return val === 159 || val === 327
    },
    auctionStart: function () {
      if (this.objekt.na_max_start && this.objekt.na_max_slutt) {
        return this.niceDateTime(this.objekt.na_max_start)
      }

      return null
    },
    lastAuction: function () {
      if (this.objekt.last_auction_time) {
        return this.niceDateTime(this.objekt.last_auction_time)
      }

      return null
    },
    auctionEnd: function () {
      if (this.objekt.Fakturadato && this.objekt.Auksjon.includes('UH')) {
        return this.niceDateTime(this.objekt.Fakturadato)
      }
      if (this.objekt.na_max_start && this.objekt.na_max_slutt) {
        return this.niceDateTime(this.objekt.na_max_slutt)
      }

      return null
    },
    auctionDate: function () {
      if (!this.objekt.na_max_start || !this.objekt.na_max_slutt) {
        return this.niceDate(this.objekt.auksjonsdato)
      }

      return null
    },
    prevAuksjon: function () {
      if (this.objekt.Auksjon && this._.startsWith(this.objekt.Auksjon, 'LY')) {
        let arr = []

        if (this.objekt.Auksjon0) {
          arr.push(this.objekt.Auksjon0)
        }

        if (this.objekt.Auksjon1) {
          arr.push(this.objekt.Auksjon1)
        }

        if (arr.length > 0) {
          return arr.join(', ')
        }
      }

      return ''
    },
    prevListAuksjon: function () {
      let arr = []

      if (this.objekt.Auksjon) {
        arr.push(this.objekt.Auksjon)
      }

      if (this.objekt.Auksjon0) {
        arr.push(this.objekt.Auksjon0)
      }

      if (this.objekt.Auksjon1) {
        arr.push(this.objekt.Auksjon1)
      }

      if (this.objekt.Auksjon2) {
        arr.push(this.objekt.Auksjon2)
      }

      if (this.objekt.Auksjon3) {
        arr.push(this.objekt.Auksjon3)
      }

      if (arr.length > 0) {
        return arr.join(' ')
      }

      return ''
    },
    isSentrum: function () {
      return this.objekt.Avdelingsid === 0 || this.objekt.Avdelingsid === '0'
    },
    canStartLagerleie: function () {
      if (!this.isPresenceOwner) {
        return false
      }

      if (!this.objekt.mottaker || this.objekt.Lagerleiedato || this.objekt.LagerleieStartDato || this.objekt.Lev_dato) {
        return false
      }

      return true
    },
    lagerleie: function () {
      if ((!this.objekt.LagerleieStartDato && !this.objekt.Lagerleiedato) || this.objekt.Lev_dato) {
        return { state: false }
      }

      const today = moment().format('YYYY-MM-DD')
      const ldato = this.objekt.Lagerleiedato ? moment(moment(this.objekt.Lagerleiedato).format('YYYY-MM-DD')) : null
      const lndato = this.objekt.LagerleieStartDato ? moment(moment(this.objekt.LagerleieStartDato).format('YYYY-MM-DD')) : null
      const lsdato = this.objekt.LagerleieStoppDato ? moment(moment(this.objekt.LagerleieStoppDato).format('YYYY-MM-DD')) : null
      const diff = ldato ? ldato.diff(this.objekt.LagerleieStoppDato || this.objekt.Lev_dato || today) : null
      const totd = diff ? Math.abs(moment.duration(diff).as('days')) : 0
      const totw = diff ? Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1) : 0
      // weeks from object
      const weeks = this.objekt.lagerleie_weeks ? this.objekt.lagerleie_weeks : totw

      return {
        state: true,
        began: !!this.objekt.Lagerleiedato,
        weeks: weeks,
        price: accounting.formatNumber(weeks * this.lagerleiePrice, { precision: 0, thousand: ' ' }),
        start: lndato,
        startCharging: ldato,
        stop: lsdato
      }
    },
    auctionInProgress: function () {
      let now = moment()
      let auctionEnd = moment(this.objekt.na_max_slutt)

      if (
        this.objekt.na_max_start &&
        this.objekt.na_max_slutt &&
        now < auctionEnd
      ) {
        return true
      }

      return false
    }
  },
  watch: {
    objekt: function (newVal, oldVal) {
      this.setupForm()
      this.addAttributes()

      if (newVal.Objektid !== oldVal.Objektid) {
        // If not same objekt, we need to reload photos...
        if (this.objekt.photos && this.objekt.photos.large && this.objekt.photos.large.length > 0) {
          this.objektImages = this.objekt.photos.large
        } else {
          this.objektImages = []

          ObjektService.getPhotoUrls(this.objekt.Objektnr, 'large')
            .then((response) => {
              this.objektImages = response.data
            })
        }
      }
    },
    'form.Lokasjonid': function (newVal, oldVal) {
      if (newVal) {
        if (newVal === '159' || newVal === 159 || newVal === '327' || newVal === 327) {
          if (oldVal !== undefined) {
            this.$set(this.form, 'Lev_dato', new Date())
          }
        } else {
          this.$set(this.form, 'Lev_dato', null)
        }
      }
    }
  },
  methods: {
    showStartLagerLeieConfirm: function () {
      const vm = this

      if (!this.isPresenceOwner) {
        return
      }

      this.openConfirm(
        'Lagerleie',
        'Vil du starte lagerleie?',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.startLagerLeie()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    showStopLagerLeieConfirm: function () {
      const vm = this

      if (!this.isPresenceOwner) {
        return
      }

      this.openConfirm(
        'Lagerleie',
        'Vil du stoppe lagerleie?',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.stopLagerLeie()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    showResetLagerLeieConfirm: function () {
      const vm = this

      if (!this.isPresenceOwner) {
        return
      }

      this.openConfirm(
        'Lagerleie',
        'Vil du tilbakestille lagringsleie?',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.resetLagerLeie()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    startLagerLeie: function () {
      this.lagerleieStartState = 'sending'

      ObjektService.startLagerleie(this.objekt.Objektid)
        .then((response) => {
          if (response.data.success) {
            const obj = this._.cloneDeep(this.objekt)
            obj.Lagerleiedato = response.data.objekt.Lagerleiedato

            bus.$emit('kunde-kontrakt-objekt-updated', obj)
            this.updateModalProps({objekt: obj})

            this.lagerleieStartState = 'success'
          } else {
            this.$helpers.showErrorAlert('Feil', response.data.message || 'Kunne ikke starte lagerleie')
            this.lagerleieStartState = null
          }
        })
        .catch((error) => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke starte lagerleie' + (error.message ? '<br>"' + error.message + '"' : ''), true)
          this.lagerleieStartState = null
        })
    },
    stopLagerLeie: function () {
      console.log('Do stop lagerleie')
      this.lagerleieStopState = 'sending'

      ObjektService.stopLagerleie(this.objekt.Objektid)
        .then((response) => {
          if (response.data.success) {
            const obj = this._.cloneDeep(this.objekt)
            obj.LagerleieStoppDato = response.data.objekt.LagerleieStoppDato

            bus.$emit('kunde-kontrakt-objekt-updated', obj)
            this.updateModalProps({objekt: obj})

            this.lagerleieStopState = 'success'
          } else {
            this.$helpers.showErrorAlert('Feil', response.data.message || 'Kunne ikke stoppe lagerleie')
            this.lagerleieStopState = null
          }
        })
        .catch((error) => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke stoppe lagerleie' + (error.message ? '<br>"' + error.message + '"' : ''), true)
          this.lagerleieStopState = null
        })
    },
    resetLagerLeie: function () {
      console.log('Do reset lagerleie')
      this.lagerleieResetState = 'sending'

      ObjektService.resetLagerleie(this.objekt.Objektid)
        .then((response) => {
          if (response.data.success) {
            const obj = this._.cloneDeep(this.objekt)
            obj.Lagerleiedato = response.data.objekt.Lagerleiedato
            obj.LagerleieStoppDato = response.data.objekt.LagerleieStoppDato

            bus.$emit('kunde-kontrakt-objekt-updated', obj)
            this.updateModalProps({objekt: obj})

            this.lagerleieResetState = 'success'
          } else {
            this.$helpers.showErrorAlert('Feil', response.data.message || 'Kunne ikke nullstille lagerleie')
            this.lagerleieResetState = null
          }
        })
        .catch((error) => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke nullstille lagerleie' + (error.message ? '<br>"' + error.message + '"' : ''), true)
          this.lagerleieResetState = null
        })
    },
    reloadPhotos: function () {
      this.reloadingPhotos = true

      ObjektService.getPhotoUrls(this.objekt.Objektnr)
        .then((response) => {
          if (response && response.data) {
            let updatedObjekt = this._.cloneDeep(this.objekt)

            if (response.data.large && response.data.large.length > 0) {
              this.objekt.Fototatt = 'T'
              updatedObjekt.Fototatt = 'T'

              this.objektImages = response.data.large
            } else {
              this.objekt.Fototatt = 'F'
              updatedObjekt.Fototatt = 'F'

              this.objektImages = []
            }

            this.$helpers.showSuccessAlert('Bilder har blitt synkronisert med ResourceSpace')

            // Emit event so we can update list
            bus.$emit('kunde-kontrakt-objekt-updated', updatedObjekt)

            this.updateModalProps({objekt: updatedObjekt})
          }
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke hente bilder fra ResourceSpace')
        })
        .then(() => {
          this.reloadingPhotos = false
        })
    },
    // saveObjektText: function (key, model) {
    //   console.log(model)
    //   // Later when we use wysiwyg
    //   // let content = this.$refs[key].innerHTML

    //   // if (!content.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '').trim()) {
    //   //   content = ''
    //   // }

    //   // console.log(content)

    //   // saveObjektText('Katalogtekst1', objekt.Katalogtekst1)
    // },
    setupForm: function () {
      // Just update form values for the one form we actually saved.
      if (!this.savingForm || this.savingForm === 'location') {
        this.$set(this.form, 'Lokasjonid', this.objekt.Lokasjonid)
        this.$set(this.form, 'Lev_dato', this.objekt.Lev_dato ? new Date(Date.parse(this.objekt.Lev_dato)) : null)
        // this.form.Lokasjonid = this.objekt.Lokasjonid
        // this.form.Lev_dato = this.objekt.Lev_dato ? new Date(Date.parse(this.objekt.Lev_dato)) : null
      }

      if (!this.savingForm || this.savingForm === 'text') {
        this.$set(this.form, 'Objekt1', this.objekt.Objekt1)
        this.$set(this.form, 'Objekt3', this.objekt.Objekt3)
        this.$set(this.form, 'Katalogtekst1', this.objekt.Katalogtekst1)
        this.$set(this.form, 'Katalogtekst2', this.objekt.Katalogtekst2)
        this.$set(this.form, 'Rettelse', this.objekt.Rettelse)

        if (this.objekt.Kategori === 'GL' && !this.objekt.NettMerknad) {
          this.$set(this.form, 'NettMerknad', 'The movement is running at the time of cataloguing, but has not been inspected. Blomqvist does not guarantee the accuracy or future working of the movement. Inspection/service recommended. Unless stated, no papers, warranties, parts or original box is included with the lot.')
        } else {
          this.$set(this.form, 'NettMerknad', this.objekt.NettMerknad)
        }
      }

      this.savingForm = null
    },
    fetch: function () {
      this.lokDropdown.unshift({key: this.objekt.Lokasjonid, val: 'Laster...'})

      InstillingerService('lokasjon').dropdown('id')
        .then((response) => {
          this.lokDropdown = response.data
          // this.lokDropdown.unshift({key: null, val: 'Velg lokasjon', disabled: true})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
        })

      // Also fetch lagerleie from vare.
      const isVin = this.objekt.Avdelingsid === 2
      const vareId = isVin ? LAGERLEIE_VIN_VARE_ID : LAGERLEIE_VARE_ID

      InstillingerService('vare').view(vareId)
        .then((response) => {
          this.lagerleiePrice = Number(response.data.Pris)
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.loadingLagerleie = false
        })
    },
    saveForm: async function (whichForm) {
      this.setFormProcessing(true)

      if (!this.isPresenceOwner && whichForm !== 'location') {
        console.log('Can not save as not owner...')
        return
      }

      this.savingForm = whichForm

      // Just send the data that needs to be updated.
      let data = {}

      // Save location/delivered form
      if (this.savingForm === 'location') {
        const validation = await Promise.all(
          [
            this.$validator.validate('Lokasjonid'),
            this.$validator.validate('Lev_dato')
          ]
        )

        const errors = validation ? validation.filter(x => x === false).length : false

        if (errors) {
          this.setFormProcessing(false)
          this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
        } else {
          data.Lokasjonid = this.form.Lokasjonid
          data.Lev_dato = this.form.Lev_dato ? moment(new Date(this.form.Lev_dato)).format('YYYY-MM-DD') : null

          if (parseInt(data.Lokasjonid) === 159 || parseInt(data.Lokasjonid) === 327) {
            data.Lokasjon = '<utlevert>'
          } else {
            data.Lokasjon = ''
          }

          KundeService.saveKundeKontraktObjekt(this.objekt.Innlevav, this.objekt.kontrakt.Kontraktnr, this.objekt.Objektid, data)
            .then((response) => {
              // Show success alert
              this.$helpers.showSuccessAlert('Objekt er lagret')

              if (this.savingForm === 'location') {
                this.lastLokId = Number(data.Lokasjonid)
                localStorage.new_obj_lokasjonid = data.Lokasjonid
              }

              // Emit event so we can update list
              bus.$emit('objekt-modal-update', response.data)
              bus.$emit('kunde-kontrakt-objekt-updated', response.data)

              this.updateModalProps({objekt: response.data})
            })
            .catch((error) => {
              console.log(error)
              this.$helpers.showErrorAlert('Feil', 'Kunne ikke lagre endringer')
            })
            .then(() => {
              this.setFormProcessing(false)
              this.setFormDirty(false)
            })
        }
      }

      // Save texts form
      if (this.savingForm === 'text') {
        data.Objekt1 = this.form.Objekt1
        data.Objekt3 = this.form.Objekt3
        data.Katalogtekst1 = this.form.Katalogtekst1
        data.Katalogtekst2 = this.form.Katalogtekst2
        data.NettMerknad = this.form.NettMerknad
        data.Rettelse = this.form.Rettelse

        KundeService.saveKundeKontraktObjekt(this.objekt.Innlevav, this.objekt.kontrakt.Kontraktnr, this.objekt.Objektid, data)
          .then((response) => {
            // Show success alert
            this.$helpers.showSuccessAlert('Objekt er lagret')

            if (this.savingForm === 'location') {
              this.lastLokId = Number(data.Lokasjonid)
              localStorage.new_obj_lokasjonid = data.Lokasjonid
            }

            // Emit event so we can update list
            bus.$emit('objekt-modal-update', response.data)
            bus.$emit('kunde-kontrakt-objekt-updated', response.data)

            this.updateModalProps({objekt: response.data})
          })
          .catch((error) => {
            console.log(error)
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke lagre endringer')
          })
          .then(() => {
            this.setFormProcessing(false)
            this.setFormDirty(false)
          })
      }
    },
    showRemoveObjectConfirm: function () {
      AuksjonService.bidHistory(this.objekt.Objektid, this.objekt.Auksjon)
        .then(data => {
          var vm = this
          var text = 'Det betyr at kunden ikke lenger kan by på nettauksjonen, eller gi forhåndsbud på nett på klassisk auksjon. Det vil heller ikke bli mulig å opprette auksjonsspade eller registrere seg for telefonbud.'
          let listObjectBids = data.data.data

          if (listObjectBids.length < 1) {
            this.openConfirm(
              'Er du sikker på at du vil fjerne dette objektet fra den gjeldende auksjonen?',
              text,
              'Ja',
              'Nei',
              function () {
                vm.removeFromAuction(vm.objekt.Objektid)
                vm.closeModal()
              },
              function () {
                vm.closeModal()
              }
            )
            return false
          }

          text += '<br><hr><table><thead><tr><th>Kundenummer</th><th>Navn</th><th>Email</th></tr></thead><tbody>'
          for (let i = 0; i < listObjectBids.length; i++) {
            text += '<tr><td><i>' + listObjectBids[i].customerNumber + '</i></td>'
            text += '<td><i>' + listObjectBids[i].name + '</i></td>'
            text += '<td><i>' + listObjectBids[i].email + '</i></td></tr>'
          }

          text += '</tbody></table>'

          this.openConfirm(
            'Er du sikker på at du vil fjerne dette objektet fra den gjeldende auksjonen?',
            text,
            'Ja',
            'Nei',
            function () {
              vm.removeFromAuction(vm.objekt.Objektid)
              vm.closeModal()
            },
            function () {
              vm.closeModal()
            }
          )
        })
        .catch((error) => {
          console.log(error)
          this.$helpers.showErrorAlert('Feil under henting av kundeliste')
        })
    },
    showChangeObjectAuction: async function () {
      var vm = this

      let auctions = await NettAuksjonService.getAuctionList()

      let confirmText = []
      confirmText.push('Velg auksjonen du vil at dette objektet skal legges til:')
      confirmText.push('<div class=\'select-container\'>')
      confirmText.push('<select id=\'Auctions\' name=\'Auctions\'>')

      auctions.data.forEach(auction => {
        confirmText.push(`<option value='${auction.NettauksjonsID}'>${auction.Navn}</option>`)
      })

      confirmText.push('</select>')
      confirmText.push('</div>')

      this.openConfirm(
        'Endre auksjon',
        confirmText.join(''),
        'Ja',
        'Nei',
        function () {
          vm.moveFromAuction(vm.objekt.Objektid)
          vm.closeModal()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    removeFromAuction: function (id) {
      NettAuksjonService.removeObject(id)
    },
    moveFromAuction: function (objectId) {
      var auctions = document.getElementById('Auctions')

      NettAuksjonService.moveObject({
        'objektid': objectId,
        'auksjonid': auctions.value
      })
    },
    niceDate: function (value) {
      if (!value) {
        return '-'
      }

      value = value.toString()

      let today = moment()
      let date = moment(value)

      if (date.isSame(today, 'day')) {
        return 'I dag'
      } else {
        return date.format('DD.MM.YYYY')
      }
    },
    niceDateTime: function (value) {
      if (!value) {
        return '-'
      }

      value = value.toString()

      let today = moment()
      let date = moment(value)

      if (date.isSame(today, 'day')) {
        return 'I dag ' + date.format('HH:mm')
      } else {
        return date.format('DD.MM.YYYY HH:mm')
      }
    },
    addAttributes: function () {
      this.attributes = []

      let list = []

      if (this._.has(this.objekt, 'objekttype.info')) {
        list.push({'name': 'Objekttype', 'value': this.objekt.objekttype.info})
      }

      if (this._.has(this.objekt, 'avdeling.Beskrivelse')) {
        list.push({'name': 'Avdeling', 'value': this.objekt.avdeling.Beskrivelse})
      }

      if (this._.has(this.objekt, 'kontraktsansvarlig.full_name')) {
        let value = this.objekt.kontraktsansvarlig.full_name

        if (this._.has(this.objekt, 'kategori.expertavdeling')) {
          if (this.objekt.kategori.expertavdeling.length > 0) {
            let found = []
            this.objekt.kategori.expertavdeling.forEach((avd) => {
              found.push(avd.Navn)
            })

            if (found.length > 0) {
              value += ': ' + found.join(', ')
            }
          }
        }

        list.push({'name': 'Ekspert', 'value': value})
      } else if (this._.has(this.objekt, 'kategori.expertavdeling')) {
        if (this.objekt.kategori.expertavdeling.length > 0) {
          let found = []

          this.objekt.kategori.expertavdeling.forEach((avd) => {
            found.push(avd.Navn)
          })

          if (found.length > 0) {
            list.push({'name': 'Ekspertavdeling', 'value': found.join(', ')})
          }
        }
      }

      if (this.isSentrum) {
        list.push({'name': 'Katalognr', 'value': this.objekt.Katalognr || '-'})
      }

      if (this.objekt.Hoyde) {
        list.push({'name': 'Høyde', 'value': this.objekt.Hoyde + (this.objekt['Hoyde_Enhet'] ? ' ' + this.objekt['Hoyde_Enhet'] : '')})
      }

      if (this.objekt.Lengde) {
        list.push({'name': 'Lengde', 'value': this.objekt.Lengde + (this.objekt['Hoyde_Enhet'] ? ' ' + this.objekt['Lengde_Enhet'] : '')})
      }

      if (this.objekt.Bredde) {
        list.push({'name': 'Bredde', 'value': this.objekt.Bredde + (this.objekt['Bredde_Enhet'] ? ' ' + this.objekt['Bredde_Enhet'] : '')})
      }

      if (this.objekt.Dybde) {
        list.push({'name': 'Dybde', 'value': this.objekt.Dybde + (this.objekt['Dybde_Enhet'] ? ' ' + this.objekt['Dybde_Enhet'] : '')})
      }

      if (this.objekt.Diameter) {
        list.push({'name': 'Diameter', 'value': this.objekt.Diameter + (this.objekt['Diameter_Enhet'] ? ' ' + this.objekt['Diameter_Enhet'] : '')})
      }

      if (this.objekt.Sittehoyde) {
        list.push({'name': 'Sittehøyde', 'value': this.objekt.Sittehoyde + (this.objekt['Sittehoyde_Enhet'] ? ' ' + this.objekt['Sittehoyde_Enhet'] : '')})
      }

      if (this.objekt.Vekt) {
        list.push({'name': 'Vekt', 'value': this.objekt.Vekt + (this.objekt['Vekt_Enhet'] ? ' ' + this.objekt['Vekt_Enhet'] : '')})
      }

      if (this.objekt.Papirmal) {
        list.push({'name': 'Papirmål', 'value': this.objekt.Papirmal + (this.objekt['Papirmal_Enhet'] ? ' ' + this.objekt['Papirmal_Enhet'] : '')})
      }

      if (this.objekt.Lysmal) {
        list.push({'name': 'Lysmål', 'value': this.objekt.Lysmal + (this.objekt['Lysmal_Enhet'] ? ' ' + this.objekt['Lysmal_Enhet'] : '')})
      }

      if (this.objekt.Trykkmal) {
        list.push({'name': 'Trykkmål', 'value': this.objekt.Trykkmal + (this.objekt['Trykkmal_Enhet'] ? ' ' + this.objekt['Trykkmal_Enhet'] : '')})
      }

      if (this.objekt.Ringstorrelse) {
        list.push({'name': 'Ringstorrelse', 'value': this.objekt.Ringstorrelse + (this.objekt['Ringstorrelse_Enhet'] ? ' ' + this.objekt['Ringstorrelse_Enhet'] : '')})
      }

      if (this.objekt.Karat) {
        list.push({'name': 'Karat', 'value': this.objekt.Karat + (this.objekt['Karat_Enhet'] ? ' ' + this.objekt['Karat_Enhet'] : '')})
      }

      if (this.objekt.Assuranseverdi) {
        list.push({'name': 'Assuranseverdi', 'value': this.objekt.Assuranseverdi + (this.objekt['Assuranseverdi_Enhet'] ? ' ' + this.objekt['Assuranseverdi_Enhet'] : '')})
      }

      if (this.objekt.Antatt_kvalitet) {
        list.push({'name': 'Antatt kvalitet', 'value': this.objekt.Antatt_kvalitet})
      }

      if (this.objekt.Argang) {
        list.push({'name': 'Årgang', 'value': this.objekt.Argang})
      }

      if (this.objekt.Antall) {
        list.push({'name': 'Antall', 'value': this.objekt.Antall})
      }

      if (this.objekt.video) {
        list.push({'name': 'Vimeo video', 'value': this.objekt.video, isLink: true})
      }

      // Split in half if has more than one element...
      if (list.length > 1) {
        let middle = Math.ceil(list.length / 2)
        let a = list.slice(0, middle)
        let b = list.slice(middle, list.length)

        this.attributes.push(a)
        this.attributes.push(b)
      } else if (list.length > 0) {
        this.attributes.push(list)
      }
    }
  }
}
</script>
<style scoped>
  dd a.external-link {
    color:blue;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabOversikt.vue